import {html} from 'lit';
import {customElement} from 'lit/decorators.js';
import {filter, fromEvent, map} from 'rxjs';
import Decimal from './break_infinity';
import {Creature} from './creature';
import {slimeTemplate} from './creature_templates';
import {Panel} from './panel';
import {p5} from './runner-idle';
import Color from 'colorjs.io';

@customElement('ri-creature-editor')
export class CreatureEditor extends Panel {
  override name = 'Creature Editor';
  override id = 'creature-editor';
  initialized = false;
  imageString = './images/player.png';
  creature: Creature = new Creature();
  p5!: typeof p5;
  r: HTMLInputElement;
  g: HTMLInputElement;
  b: HTMLInputElement;

  updateInputs() {
    if (!this.r) {
      this.r = this.shadowRoot?.getElementById('r');
    }
    if (!this.g) {
      this.g = this.shadowRoot?.getElementById('g');
    }
    if (!this.b) {
      this.b = this.shadowRoot?.getElementById('b');
    }
    if (this.r) {
      this.r.value = this.creature.imageHues[0].toString({format: 'hex'});
    }
    if (this.g) {
      this.g.value = this.creature.imageHues[1].toString({format: 'hex'});
    }
    if (this.b) {
      this.b.value = this.creature.imageHues[2].toString({format: 'hex'});
    }
  }

  setupP5 = (creature: Creature) => (p: typeof p5) => {
    let pCanvas;
    p.preload = function () {};
    p.setup = function () {
      pCanvas = p.createCanvas(512, 512);
      pCanvas.style('visibility', 'visible');
      p.noSmooth();
    };
    p.draw = function () {
      p.background(0);
      creature.updateImage(p);
      if (creature.image) {
        p.image(creature.image, 0, 0, 512, 512, 0, 0, 32, 32);
      }
    };
  };

  override render() {
    const canvas = this.shadowRoot?.getElementById('canvas');
    if (canvas) {
      if (!this.initialized) {
        this.creature = Creature.create({
          ...slimeTemplate,
          imageString: 'slime',
        });
        this.p5 = new p5(this.setupP5(this.creature), canvas);
        this.initialized = true;
        this.updateInputs();
        fromEvent(this.r, 'input')
          .pipe(
            map((event) => event?.target?.value)
            // filter((colorString) => colorString.length == 7)
          )
          .subscribe(
            (colorString) =>
              (this.creature.imageHues[0] = new Color(colorString))
          );
        fromEvent(this.g, 'input')
          .pipe(
            map((event) => event?.target?.value)
            // filter((colorString) => colorString.length == 7)
          )
          .subscribe(
            (colorString) =>
              (this.creature.imageHues[1] = new Color(colorString))
          );
        fromEvent(this.b, 'input')
          .pipe(
            map((event) => event?.target?.value)
            // filter((colorString) => colorString.length == 7)
          )
          .subscribe(
            (colorString) =>
              (this.creature.imageHues[2] = new Color(colorString))
          );
      }
    }
    return super.render(html`
      R: <input id="r" type="color" /> G: <input id="g" type="color" /> B:
      <input id="b" type="color" />
      <div id="canvas"></div>
    `);
  }
}
